/**
 * Indique si un panneau avancé AutoComplete (F8) est monté dans le DOM.
 * Utilisé pour donner priorité au F3 du panneau vs le F3 de U2000BasicSearch (BL-0407).
 */
export const U2000_AUTOCOMPLETE_ADVANCED_PANEL_ATTR = 'data-u2000-autocomplete-panel';

export function u2000IsAutocompleteAdvancedPanelOpen(
  root: ParentNode | null | undefined = typeof document !== 'undefined' ? document : null,
): boolean {
  if (!root || typeof root.querySelector !== 'function') {
    return false;
  }
  return root.querySelector(`[${U2000_AUTOCOMPLETE_ADVANCED_PANEL_ATTR}="true"]`) != null;
}
